import React from 'react'
import _ from "lodash";
import {COLOR_LIST} from "../../../../common/constants/color.constant";

const colorList = _.orderBy(COLOR_LIST, 'colorKey');

// @ts-ignore
const EditShadowDetails = ({parentForm, handleShadowDetailsChanges}) => {
    const colorMap = _.keyBy(COLOR_LIST, 'colorKey');

    return (
        <>
            <div className="ml-2 field-label">
                Shadow Color & Shade
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="shadowColorKey"
                            name="shadowColorKey"
                            value={parentForm?.shadowColorKey}
                            onChange={(event) => {
                                handleShadowDetailsChanges(event, parentForm);
                            }}>
                            {/*<option value="">Choose Shadow Color</option>*/}
                            <option value="">Choose Color</option>
                            {colorList?.map((colorDetail, index) => (
                                <option key={index}
                                        value={colorDetail.colorKey}>{colorDetail.colorName}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="shadowColorCodeKey"
                            name="shadowColorCodeKey"
                            value={parentForm?.shadowColorCodeKey}
                            onChange={(event) => {
                                handleShadowDetailsChanges(event, parentForm);
                            }}>
                            {/*<option value="">Choose Shadow Color Shade</option>*/}
                            <option value="">Choose Shade</option>
                            {colorMap[parentForm?.shadowColorKey]?.colorCodes.map((colorCodeDetail, index) => (
                                <option key={index}
                                        value={colorCodeDetail.colorCodeKey}>{colorCodeDetail.colorCodeName}</option>
                            ))}
                        </select>
                    </div>

                </div>
            </div>

            <div className="ml-2 field-label">
                Shadow Offset (X, Y) & Shadow Blur
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">

                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field w-28"
                            id="shadowOffsetX"
                            name="shadowOffsetX"
                            value={parentForm?.shadowOffsetX}
                            onChange={(event) => {
                                handleShadowDetailsChanges(event, parentForm);
                            }}>
                        </input>
                    </div>

                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field w-28"
                            id="shadowOffsetY"
                            name="shadowOffsetY"
                            value={parentForm?.shadowOffsetY}
                            onChange={(event) => {
                                handleShadowDetailsChanges(event, parentForm);
                            }}>
                        </input>
                    </div>

                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field w-28"
                            id="shadowBlur"
                            name="shadowBlur"
                            value={parentForm?.shadowBlur}
                            onChange={(event) => {
                                handleShadowDetailsChanges(event, parentForm);
                            }}>
                        </input>
                    </div>

                </div>
            </div>

            {/*<div className="ml-2 field-label">
                Shadow Blur
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">

                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field"
                            id="shadowBlur"
                            name="shadowBlur"
                            value={parentForm?.shadowBlur}
                            onChange={(event) => {
                                handleShadowDetailsChanges(event, parentForm);
                            }}>
                        </input>
                    </div>

                </div>
            </div>*/}

        </>
    )
}

export default EditShadowDetails
